var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var TEXT_FORMAT_SETTINGS = [
    'isBold',
    'isItalic',
    'isUnderline',
    'fontSize',
    'font',
    'fontColor',
    'fontWidthFactor',
    'lineSpaceFactor'
];
export var setGlobalSectionSettingsAction = function (payload) {
    return {
        type: 'APP_SETTINGS/SET_SECTION_SETTINGS',
        payload: payload,
    };
};
export var setGlobalPageSettingsAction = function (payload) {
    return {
        type: 'APP_SETTINGS/SET_PAGE_SETTINGS',
        payload: payload,
    };
};
export var setGlobalSettingsAction = function (payload) {
    return {
        type: 'APP_SETTINGS/SET_GLOBAL_SETTINGS',
        payload: payload,
    };
};
export var resetGlobalSettingsAction = function () {
    return {
        type: 'APP_SETTINGS/RESET_GLOBAL_SETTINGS',
    };
};
export var setGlobalSectionSettingsActionThunk = function (payload) {
    return function (dispatch) {
        var properties = Object.entries(payload).reduce(function (acc, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            if (TEXT_FORMAT_SETTINGS.includes(key)) {
                return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
            }
            return acc;
        }, {});
        dispatch(setGlobalSectionSettingsAction(properties));
    };
};
export var getGlobalSettingsActionThunk = function (payload) {
    return function (dispatch) {
        var settings = Object.entries(payload).reduce(function (acc, _a) {
            var _b = __read(_a, 2), settingKey = _b[0], settingValue = _b[1];
            switch (settingKey) {
                case 'section': {
                    return __assign(__assign({}, acc), { section: Object.entries(settingValue).reduce(function (acc, _a) {
                            var _b = __read(_a, 2), key = _b[0], value = _b[1];
                            switch (key) {
                                case 'bold': {
                                    return __assign(__assign({}, acc), { isBold: value });
                                }
                                case 'italic': {
                                    return __assign(__assign({}, acc), { isItalic: value });
                                }
                                case 'underline': {
                                    return __assign(__assign({}, acc), { isUnderline: value });
                                }
                                case 'text_height': {
                                    return __assign(__assign({}, acc), { fontSize: value });
                                }
                                case 'font_name': {
                                    return __assign(__assign({}, acc), { font: value });
                                }
                                case 'color': {
                                    return __assign(__assign({}, acc), { fontColor: value });
                                }
                                case 'font_width_factor': {
                                    return __assign(__assign({}, acc), { fontWidthFactor: value });
                                }
                                case 'line_spacing': {
                                    return __assign(__assign({}, acc), { lineSpaceFactor: value });
                                }
                                default: {
                                    return acc;
                                }
                            }
                        }, {}) });
                }
                case 'page': {
                    return __assign(__assign({}, acc), { page: Object.keys(settingValue).reduce(function (acc, key) {
                            var _a;
                            if (settingValue === null || settingValue === void 0 ? void 0 : settingValue.hasOwnProperty(key)) {
                                return __assign(__assign({}, acc), (_a = {}, _a[key] = settingValue[key], _a));
                            }
                            return acc;
                        }, {}) });
                }
                default: {
                    return acc;
                }
            }
        }, {});
        dispatch(setGlobalSettingsAction(settings));
    };
};
export default {
    setGlobalSectionSettingsAction: setGlobalSectionSettingsAction,
    setGlobalPageSettingsAction: setGlobalPageSettingsAction,
    setGlobalSettingsAction: setGlobalSettingsAction,
    resetGlobalSettingsAction: resetGlobalSettingsAction,
};
